import React, { useState, useEffect } from "react"
import { Box,  Heading, Button, Text, Center } from "@chakra-ui/react"
import Filter from "../../components/Project/Filter"
import ProjectItem from "../../components/Project/ProjectItem"
import projectsJson from '../../data/projects.json'
import Transition from "../../components/Layout/Transition"
import Background from "../../components/Layout/Background"
import a from "../../images/background/423.svg"
import b from "../../images/background/4.svg"


export default function Projects() {
    const { projects ,  filter } = JSON.parse(JSON.stringify(projectsJson))
    const [list, setList] = useState(projects)
    const [size, setSize] = useState(4)
    const [show, setShow] = useState(false)

    useEffect(() => {
        if (show === true) {
            setSize(list.length)
        } else {
            setSize(4)
        }     
    }, [show])

    return (
        <section>
            <Box position="relative" py={20}>
                <Background src={a} left="-22vw" top="15vw" width='15vw' />
                <Background src={b} right="-22vw" bottom="15vw" width='15vw'/>
                <Heading as="h1" size="3xl" mb={5}>👨🏻‍💻 Projects</Heading>
                <Filter items={filter} setList={setList} projects={projects} />
                {list.length === 0 && (
                    <Center mt={20}>
                        <Text fontSize="3xl" fontWeight={700}>No projects on this category 🙅🏻</Text>
                    </Center>
                )}
                {list.slice(0, size).map((project, i) => {
                    return (
                    <Transition>
                        <ProjectItem 
                            key={i} 
                            title={project.title} 
                            description={project.description} 
                            link={project.githubLink} 
                            techStack={project.techStack} 
                        />
                    </Transition>
                    )
                })}
                {(list.length >= 4 && !show) && 
                <Center mt={10}>
                    <Button colorScheme="teal" size="lg" onClick={() => setShow(!show)}>
                        <Text pt={1}>
                            Show More
                        </Text>
                    </Button>
                </Center>}
            </Box>
        </section>
    )
}